import React from 'react';

import { StripeElementsProvider } from '@order/integrations-stripe';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Provides the Stripe Elements context required by the web payment element.
 * On native, the Stripe SDK is provided at the app root, so this is a passthrough.
 */
export const SweetpassPaymentProvider = (props: Props) => {
  const { children, amount, sessionId, onFailedToLoadStripe } = props;

  return (
    <StripeElementsProvider
      source="sweetpass"
      amount={amount}
      sessionId={sessionId}
      onFailedToLoadStripe={onFailedToLoadStripe}
    >
      {children}
    </StripeElementsProvider>
  );
};

// ─── Props ───────────────────────────────────────────────────────────────────

type Props = Omit<React.ComponentProps<typeof StripeElementsProvider>, 'source'>;
